<template>
  <div>
    <div class="con-tab-ejemplo">
      <div class="vx-row">
        <div class="vx-col w-full vx-coll-fixed-hight text-center">
          <vs-table :data="feeDetails">
            <template slot="thead">
              <vs-th class="w-1/12"><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableFeeDetail.no') }}</span></vs-th>
              <vs-th class="w-1/4"><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableFeeDetail.type') }}</span></vs-th>
              <vs-th class="w-1/4"><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableFeeDetail.date') }}</span></vs-th>
              <vs-th class="w-1/3"><span class="ml-auto mr-auto">{{ $t('sections.accounting.dataForm.tableFeeDetail.amount') }}</span></vs-th>
              <vs-th class="w-1/12"></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(res, index) in data" :state="isAdjustmentState(res)">
                <vs-td :data="(index+1)">
                  {{ (index+1) }}
                </vs-td>
                <vs-td :data="res.feeType">
                  {{ res.feeType | feeType}}
                </vs-td>
                <vs-td :data="res.feeDate">
                  {{ res.feeDate | convYYYYMMDDToDDMMYYYY }}
                </vs-td>
                <vs-td :data="res.amount">
                  {{ res.amount | numberFormat}}
                  <small v-if="(res.adjustment)"><u>{{ $t('sections.accounting.dataForm.adjustment') }}</u></small>
                </vs-td>
                <vs-td>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete" @click="delFeeDetail(res.id)" v-show="!isHideDelFeeDetail(res)"></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');

export default {
  props: ['manage'],
  computed:{
    ...mapAccountingState([
      'status',
      'contract',
      'feeDetails',
    ])
  },
  methods: {
    ...mapAccountingActions([
      'deleteFeeDetail',
    ]),
    isHideDelFeeDetail (res){
      if(!res.transaction && this.manage){
        return false
      }
      return true
    },
    isAdjustmentState(res){
      let isState = null
      if(res.adjustment){
        isState = "warning"
      }
      return isState
    },
    async delFeeDetail (id) {
      this.actionID = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: this.acceptDelFeeDetail
      })
    },
    async acceptDelFeeDetail () {
      await this.deleteFeeDetail({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
  },
}
</script>

<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
</style>
